import { render, staticRenderFns } from "./CreateWorksheetsFromWasteBinReadingsModal.yaml?vue&type=template&id=70239722&component"
import script from "./CreateWorksheetsFromWasteBinReadingsModal.yaml?vue&type=script&lang=ts&component"
export * from "./CreateWorksheetsFromWasteBinReadingsModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports